// extracted by mini-css-extract-plugin
export default {"products":"Fy-z","card":"Gy-z","oosMessaging":"Hy-z"};